import type { AppStore } from "@/store/AppStore";
import type {
  GetAssistantTaskInput,
  GetAssistantTaskOutput,
} from "@mem-client/ai-toolkit/contract";
import {
  AiToolkitToolName,
  getAssistantTaskInputSchema,
  getAssistantTaskOutputSchema,
} from "@mem-client/ai-toolkit/contract";
import { AiToolkitAssistantTaskNotFoundError } from "@/modules/ai-toolkit/errors";
import type { AiToolkitToolDefinition } from "@/modules/ai-toolkit/tools/types";
import {
  buildAssistantTaskFromCreateChangeRequestUpdateValue,
  buildAssistantTaskFromSyncUpdateValue,
  isCreateTaskChangeRequestUpdateValue,
} from "@/modules/ai-toolkit/tools/assistant-tasks/assistant-task-tools.helpers";

export const getAssistantTask = async ({
  store,
  input,
}: {
  store: AppStore;
  input: GetAssistantTaskInput;
}): Promise<GetAssistantTaskOutput> => {
  const taskRow = await store.assistantTasks.localTable.get(input.taskId);

  if (taskRow) {
    return {
      task: buildAssistantTaskFromSyncUpdateValue({ updateValue: taskRow }),
    };
  }

  const changeRequestRow = await store.assistantTaskChangeRequests.localTable.get(input.taskId);

  if (
    !changeRequestRow ||
    !isCreateTaskChangeRequestUpdateValue({ updateValue: changeRequestRow })
  ) {
    throw new AiToolkitAssistantTaskNotFoundError({ taskId: input.taskId });
  }

  return {
    task: buildAssistantTaskFromCreateChangeRequestUpdateValue({
      updateValue: changeRequestRow,
    }),
  };
};

export const getAssistantTaskTool: AiToolkitToolDefinition<
  AiToolkitToolName.GetAssistantTask,
  GetAssistantTaskInput,
  GetAssistantTaskOutput
> = {
  name: AiToolkitToolName.GetAssistantTask,
  inputSchema: getAssistantTaskInputSchema,
  outputSchema: getAssistantTaskOutputSchema,
  strict: true,
  execute: getAssistantTask,
};
